import React from 'react';

import { Select } from 'components/ui/select';
import { formatMetrics } from './metrics/helpers';

import type { Agent, Message, Metrics, Model } from './types';

interface Props {
  agent: Agent | null;
  agents: Agent[];
  messages: Message[];
  model: Model | null;
  models: Model[];
  onAgentChange: (agent: Agent) => void;
  onModelChange: (model: Model) => void;
}

export default function AdminToolbar({
  agent,
  agents,
  messages,
  model,
  models,
  onAgentChange,
  onModelChange,
}: Props) {
  const aggregateMetrics: Metrics = { cost: null, latencyMs: null };


  for (const message of messages) {
    if (message.metrics?.cost != null) {
      aggregateMetrics.cost ||= 0;
      aggregateMetrics.cost += message.metrics.cost;
    }

    if (message.metrics?.latencyMs != null) {
      aggregateMetrics.latencyMs ||= 0;
      aggregateMetrics.latencyMs += message.metrics.latencyMs;
    }
  }

  return (
    <div className="border-bottom px-3 py-2">
      <div className="d-flex align-items-center gap-2">
        <div className="flex-grow-1" style={{ minWidth: 0 }}>
          <Select
            getOptionLabel={agent => agent.label}
            getOptionValue={agent => agent.name}
            options={agents}
            value={agent}
            onChange={onAgentChange}
          />
        </div>

        <div className="flex-grow-1" style={{ minWidth: 0 }}>
          <Select
            getOptionLabel={model => `${model.id} · ${model.provider}`}
            getOptionValue={model => model.id}
            options={models}
            value={model}
            onChange={onModelChange}
          />
        </div>
      </div>

      <div className="text-muted small text-nowrap text-end mt-1" title="Session LLM latency and spend">
        {formatMetrics(aggregateMetrics)}
      </div>
    </div>
  );
}
